import * as React from 'react';

import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';

import { AppErroredPage } from '@components/AppErroredPage';

import { store } from './api';

export const Context: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => (
  <Provider store={store}>
    <Sentry.ErrorBoundary fallback={(e) => <AppErroredPage {...e} />}>{children}</Sentry.ErrorBoundary>
  </Provider>
);
